// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"menuText": "#bfcbd9",
	"menuActiveText": "#409EFF",
	"subMenuActiveText": "#f4f4f5",
	"menuBg": "#FFFFFF",
	"menuHover": "var(--rowHover)",
	"subMenuBg": "#FFFFFF",
	"subMenuHover": "var(--rowHover)",
	"sideBarWidth": "200px"
};
module.exports = exports;
